import { render, staticRenderFns } from "./Xunyee.vue?vue&type=template&id=6237b28c&"
import script from "./Xunyee.vue?vue&type=script&lang=js&"
export * from "./Xunyee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports